import { checkEnvironment } from '@saviynt/common';

const getExtendSessionUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/privilegedinstance/extendsession`;
};

export default getExtendSessionUrl;
